import type { FC, SVGProps } from 'react'

import LogoWordmarkImg from '../../../assets/img/logo-wordmark.svg?react'

const LogoWordmark: FC<SVGProps<SVGSVGElement> & { title?: string }> = (props) => {
  return <LogoWordmarkImg width={117} height={18} {...props} />
}

export default LogoWordmark
